import type { UseQueryResult } from '@tanstack/react-query';

import { useQuery } from '@tanstack/react-query';

import type { EtcaRedirect } from '../../api/types/etcaRedirect.types';

import { getEtcaRedirect } from '../../api/get-etca-redirect/getEtcaRedirect';

export function useEtcaRedirectQuery(
    geminiReservationId: string
): UseQueryResult<EtcaRedirect, Error> {
    return useQuery<EtcaRedirect, Error>({
        queryKey: ['etca-redirect', geminiReservationId],
        queryFn: (): Promise<EtcaRedirect> => getEtcaRedirect(geminiReservationId),
        enabled: !!geminiReservationId,
        retry: false,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    });
}
